import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Sparkles, ChevronDown } from "lucide-react";

export default function CareerHero() {
  const navigate = useNavigate();

  const goToOpportunities = () => {
    navigate("/careers");
  };

  return (
    <section
      id="careers"
      data-testid="career-hero-section"
      className="relative min-h-screen w-full overflow-hidden hero-radial flex items-center"
    >
      {/* Background gradient overlay */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(6,6,6,0.55) 0%, rgba(6,6,6,0.35) 40%, rgba(6,6,6,0.9) 100%)",
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full grid md:grid-cols-2 gap-10 items-center pt-28 pb-24">
        <div className="text-reveal">
          <div className="eyebrow mb-6">
            <Sparkles size={14} /> Build With Us
          </div>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.05] font-semibold">
            Career{" "}
            <span className="gold-text-gradient italic">With Us</span>
            <br />
            at Elite Eventz
          </h1>

          <p className="mt-7 text-lg text-neutral-300 max-w-xl leading-relaxed">
            At Elite Eventz, we believe great experiences are created by
            passionate people. Explore opportunities to collaborate, create,
            execute and grow with us.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <button
              onClick={goToOpportunities}
              data-testid="career-cta-explore"
              className="btn-gold"
            >
              Explore Opportunities <span aria-hidden>→</span>
            </button>
          </div>
        </div>

        <div className="relative hidden md:block">
          {/* Right side visual */}
          <motion.div
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
            className="relative aspect-[4/5] w-full max-w-md ml-auto glass rounded-3xl overflow-hidden bg-black"
          >
            <img
              src="/ExploreOpprtunitiesImage.jpeg"
              alt="Explore Opportunities at Elite Eventz"
              className="w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.8 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-2"
      >
        <span className="text-xs uppercase tracking-wider text-neutral-500">
          Scroll to explore
        </span>
        <div className="scroll-dot" />
      </motion.div>
    </section>
  );
}
